
<template> 
  <div class="div-regione mb-3">  
    <div class="card-body card-body-cascade text-center">
      <img :src="imagePath" class="img-fluid" width="50px" height="50px">
      <span class="card-title"><strong>{{regione}}</strong></span> &nbsp;<span class="badge badge-pill badge-iptv text-white">{{count}}</span>
    </div>
  </div> 
    
</template>

<script>


export default {
  name: 'CardRegione',
  data: function() {
    return  {
      
    };
  },
  props: ['regione','count'],
  methods: {       
  },
  computed: {  
    imagePath: function() {
          return require("../assets/images/icona_italia.png");
      }, 
  }
}
</script>


<style scoped>
  
.btn-rounded {

  background-color: #009EE2;
  border: none;
  color: white;
  padding: 10px;
  text-align: center;
  text-decoration: none;
  font-size: 16px;
  margin: 4px 2px;
  border-radius: 50%;
  box-shadow: 0 5px 11px 0 rgba(0,0,0,.18), 0 4px 15px 0 rgba(0,0,0,.15);
  width:50px;
  height:50px;
}

.card-title {
  font-size: 1.5rem;
}

</style>